import { render, staticRenderFns } from "./AcademyBranches.vue?vue&type=template&id=05393a7e&scoped=true&lang=pug&"
import script from "./AcademyBranches.vue?vue&type=script&lang=ts&"
export * from "./AcademyBranches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05393a7e",
  null
  
)

export default component.exports